import React, { FunctionComponent, useContext } from 'react';
import { EventModel } from 'features/events/EventModel';
import { EmptyEvents } from 'features/channel/components/ChannelEvents/EmptyEvents';
import { PaginatedEvents } from 'features/channel/components/ChannelEvents/PaginatedEvents';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { InfiniteScrollEvents } from './InfiniteScrollEvents';
import { useAppSelector } from 'hooks/redux';
import {
  liveEventSelector,
  upcomingEventSelector
} from 'features/events/eventsSelectors';
import { Card } from 'components/Card';

export const ChannelEvents: FunctionComponent = () => {
  const channel = useAppSelector((state) => state.channel.channelDetails);
  const channelisLoaded = useAppSelector((state) => state.channel.isLoaded);
  const liveEvent: EventModel | null = useAppSelector(liveEventSelector);
  const upcomingEvents: EventModel[] = useAppSelector(upcomingEventSelector);
  const { isListenerAppWebview } = useContext(UserAgentContext);
  const itemsPerPage = 21;

  if (!channelisLoaded || channel == null) {
    return null;
  }

  return (
    <div className="container--wide tw-mt-8 standalone:tw-mt-0 [.ios_&]:tw-mt-0 [.android_&]:tw-mt-0">
      {liveEvent && (
        <Card
          id={liveEvent.id}
          url={`/events/${liveEvent.id}`}
          title={`${liveEvent.title}`}
          artwork={liveEvent.artwork}
          artworkKey={liveEvent.artworkKey}
          artworkMode={liveEvent.artworkMode}
          isFallback={liveEvent.fallback}
          isPrivate={liveEvent.isPrivate()}
          isActive={liveEvent.isLive()}
          updatedTimestamp={liveEvent.lastUpdatedAt}
          type={'event'}
          isFeatured={true}
          isFeaturedListView={true}
          color={liveEvent.color}
        />
      )}
      {upcomingEvents.length === 0 ? (
        <EmptyEvents username={channel.username} />
      ) : isListenerAppWebview ? (
        <InfiniteScrollEvents events={upcomingEvents} />
      ) : (
        <PaginatedEvents events={upcomingEvents} itemsPerPage={itemsPerPage} />
      )}
    </div>
  );
};
